<script lang="ts" setup>
  import { InputWidthVariant } from '../../InputWrapper';
  import { useField } from 'vee-validate';
  import { toRef, toRefs } from 'vue';
  import type {
    CheckableSelectProps,
    CheckableSelectItem,
  } from './CheckableSelect.types';
  import CheckableSelect from './CheckableSelect.vue';

  export type CheckableSelectFieldProps = Omit<
    CheckableSelectProps,
    'modelValue'
  > & {
    rules?: (value: CheckableSelectItem[]) => string | boolean;
  };

  const props = withDefaults(defineProps<CheckableSelectFieldProps>(), {
    rules: undefined,
    searchable: true,
    showLabels: false,
    showNoOptions: true,
    resettable: false,
    showNoResults: true,
    allowEmpty: false,
    taggable: false,
    disabled: false,
    meta: undefined,
    internalSearch: true,
    valueKey: 'value',
    labelKey: 'label',
    width: InputWidthVariant.FULL,
  });

  const {
    name: inputName,
    label,
    rules,
    ...rest
  } = toRefs<CheckableSelectFieldProps>(props);
  // workaround to keep reactivity on rest value from toRefs
  const inputProps = toRef(rest);

  const {
    value: inputValue,
    errorMessage,
    handleBlur,
    handleChange,
    meta,
  } = useField<CheckableSelectItem[]>(inputName.value, rules?.value, {
    label: label?.value,
  });
</script>

<template>
  <CheckableSelect
    v-bind="inputProps"
    :error="errorMessage as string"
    :label="label"
    :meta="meta"
    :loading="loading"
    :model-value="inputValue"
    :name="name"
    :open-direction="openDirection"
    :placeholder="placeholder"
    @blur="handleBlur"
    @update:model-value="handleChange"
  />
</template>
